"use client";

import React from "react";
import { ZoomIn } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const portfolioItems = [{
  id: 1,
  title: "PRECISION FDM PRINTS",
  category: "3D Printing",
  description: "High-resolution lithophanes to complex geometries. Material: ABS | Process: FDM Printing",
  image: "https://quinnstudio.xyz/wp-content/uploads/2026/03/53d6e353-f4f0-4fe9-b5f3-d1f1605cfc0f.jpg?v=ar2uhfhltjo"
}, {
  id: 2,
  title: "MANY MATERIAL OPTIONS",
  category: "Laser Engraving",
  description: "Deep-grain engraving on sustainably sourced solid basswod or creating light engraved stainless steel, we can do it all. Material: Basswood | Process: Diode Laser",
  image: "https://quinnstudio.xyz/wp-content/uploads/2026/03/735b6897-83c9-4cb0-a7a0-de875b8c55b9-scaled.jpg?v=ewamtpql8ch"
}, {
  id: 3,
  title: "3D MODELING",
  category: "Digital Design",
  description: "Our engineers can help take your vision and turn it in to a reality.",
  image: "https://quinnstudio.xyz/wp-content/uploads/2026/03/Screenshot-2026-01-08-084603.png?v=7xhxav0baua"
}, {
  id: 4,
  title: "MULTI-MATERIAL\xA0",
  category: "3D Printing",
  description: "FDM Printing processes in a vast array of materials and colors. Material: ABS | Process: FDM Printing",
  image: "https://quinnstudio.xyz/wp-content/uploads/2026/03/PXL_20250410_044232379-scaled.jpg?v=b8irog3w6ed"
}, {
  id: 5,
  title: "BESPOKE SOLUTION",
  category: "Laser Engraving",
  description: "Whether it is marketing logos, small projects, or functional designs, we have you covered.",
  image: "https://quinnstudio.xyz/wp-content/uploads/2026/03/597847678_10224400118230715_1588261827476692188_n.jpg?v=jyrmkqdobvs"
}, {
  id: 6,
  title: "LASER FILE DESIGN",
  category: "Digital Design",
  description: "Engineers work with your design criteria, keeping modern design philosphies and economics in mind, to get the design layed out right the first time with little waste.",
  image: "https://quinnstudio.xyz/wp-content/uploads/2026/03/fa639b6e-0b2c-47a8-96fa-4842093a315f-1-1-scaled.jpg?v=9b9r51pfx4j"
}];
export default function OurVisualLegacy() {
  return <section data-section-id="152070" id="the-fabrication-gallery" className="py-24 bg-background text-foreground dark">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16 space-y-4">
          <Badge variant="outline" className="uppercase tracking-widest text-primary border-primary/30 bg-primary/10 rounded-none font-mono text-xs">
            Portfolio
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tighter font-sans text-foreground">
            The Fabrication Gallery
          </h2>
          <p className="max-w-[700px] text-muted-foreground md:text-lg/relaxed font-sans">A showcase of industrial precision and creative engineering, from rapid prototypes to bespoke solutions.</p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {portfolioItems.map((item, i) => <div key={item.id} data-index={i} className="break-inside-avoid">
              <Dialog>
                <DialogTrigger asChild>
                  <div className="group relative cursor-pointer overflow-hidden rounded-none border border-border/20 bg-card shadow-none transition-all duration-300 hover:border-primary/50" tabIndex={0} role="button" aria-label={`View details for ${item.title}`}>
                    <div className="relative aspect-auto w-full overflow-hidden bg-muted">
                      <img src={item.image} alt={item.title} className="w-full h-auto object-cover grayscale brightness-75 transition-all duration-500 ease-in-out group-hover:scale-100 group-hover:grayscale-0 group-hover:brightness-100" loading="lazy" />
                      
                      {}
                      <div className="absolute top-4 left-4 z-10">
                        <Badge variant="secondary" className="bg-background/90 backdrop-blur-none border-border/50 text-foreground rounded-none font-mono text-[10px] uppercase tracking-wider">
                          {item.category}
                        </Badge>
                      </div>

                      {}
                      <div className="absolute inset-0 z-20 flex items-center justify-center bg-background/40 opacity-0 backdrop-blur-none transition-opacity duration-300 group-hover:opacity-100">
                        <div className="rounded-none bg-primary p-3 shadow-none transform translate-y-0 opacity-0 transition-all duration-300 group-hover:opacity-100">
                          <ZoomIn className="size-6 text-primary-foreground" />
                        </div>
                      </div>
                    </div>
                  </div>
                </DialogTrigger>
                
                <DialogContent className="max-w-4xl bg-card border-border shadow-2xl rounded-none overflow-hidden p-0 gap-0">
                  <div className="grid md:grid-cols-2 h-full max-h-[85vh]">
                    <div className="relative h-64 md:h-full w-full bg-muted">
                      <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover" />
                    </div>
                    <div className="flex flex-col justify-center p-8 md:p-12 bg-card">
                      <DialogHeader className="text-left space-y-4">
                        <Badge className="w-fit bg-secondary text-secondary-foreground rounded-none border-none font-mono text-xs uppercase tracking-widest">
                          {item.category}
                        </Badge>
                        <DialogTitle className="text-2xl md:text-3xl font-sans font-bold tracking-tight leading-tight uppercase">
                          {item.title}
                        </DialogTitle>
                        <DialogDescription className="text-base md:text-lg text-muted-foreground leading-relaxed pt-4 border-t border-border/20 font-sans">
                          {item.description}
                        </DialogDescription>
                      </DialogHeader>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}